import {Link} from 'react-router-dom';
import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';

import {useracc} from '../../utils/functions';
import {UserContext} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import '../components/fontawesome/fontawesome';

import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';


export default class AccountLogin extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			status: true,
			password: {
				text: '',
				valid: false,
				error: '',
				visible: false,
			},
			cookies: navigator.cookieEnabled
		};
		localStorage.setItem('returnTo', window.location.href);
		this.getUser = this.getUser.bind(this);
		this.passwordVisability = this.passwordVisability.bind(this);
  };


  async componentDidMount() {
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		value.setTheme( getUser );
		EventEmitter.emit('/client', {data: 'no value'});
	}


	componentWillUnmount() {
	}


	getUser = (e) => {
    this.setState({await: true});
    e.preventDefault();
    const params = new URLSearchParams();
    params.append('username', e.target.elements.username.value);
    params.append('password', e.target.elements.password.value);
    params.append('remember', e.target.elements.remember.checked);
    params.append('cookie', localStorage.getItem('cookie'));
    if(this.state.totp === true)
    params.append('totp', e.target.elements.totp.value);
    axios.post(`/v3/account/login`, params, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      withCredentials: true
    })
    .then((res) => {
      if( res.data.error ) {
        if( res.data.error === "Recover" ) {
          window.location.href = '/recover';  
        } else {
          const element = res.data.error;
          ReactDOM.render( element, document.getElementById('error') );
          this.setState({await: false, totp: false});
        }
      } else {
				EventEmitter.emit('/socket/reconnect', {data: 'no value'});

				let cookies = document.cookie.split(';');
				cookies = cookies.map(cookie => cookie.split("="));
				for( let i in cookies ) {
					if( cookies[i][0] === 'returnFixed' ) {
						window.location.href = cookies[i][1];
						return;
					}
					if( cookies[i][0] === 'order' ) {
						window.location.href = '/cart';
						return;
					}
				}

				let returnTo = localStorage.getItem('returnTo');
				if( returnTo ) {
					localStorage.removeItem('returnTo');
					window.location.href = returnTo;
				} else {
					window.location.href = `/`;
				}
      }
    })
    .catch(error => {
      if (error.message === "Network Error"){
				setTimeout(_ => {
        	this.getUser(e);
      	}, 5000);
			}
    });
  }
	
	passwordVisability() {
		let password = this.state.password;
		password.visible = !password.visible;
		this.setState({password});
	}

	render() {
		
		return (
			<>
				<div className="container">
					
					<div className="row justify-content-center">
						<div className="col-xl-8 col-md-12 col-sm-10" style={{userSelect: 'none'}}>
							<div className="card custom-card  rectangle2">
								<div className="card-body p-0 ">
									<div className="row">
										<div className="col-xl-6 col-md-6 pe-sm-0">
											<Form onSubmit={this.getUser}>
												<div className="p-sm-5 p-3">
													<p className="h4 fw-semibold mb-2">Sign In</p>
													<p className="mb-3 text-muted op-7 fw-normal">Welcome back!</p>
													<p id="error" className="text-secondary fw-semibold">&nbsp;</p>
													<div className="row gy-3 mt-3">
														<div className="col-xl-12 mt-0">
															<label htmlFor="signin-username" className="form-label text-default">User Name</label>
															<input type="text" className="form-control form-control-lg" id="signin-username" placeholder="user name" name="username" required />
														</div>
														<div className="col-xl-12 mb-3">
															<label htmlFor="signin-password" className="form-label text-default d-block">Password<Link to="/recover" className="float-end text-primary">Forget password ?</Link></label>
															<div className="input-group">
																<input type={this.state.password.visible===true?'text':'password'} className="form-control form-control-lg" id="signin-password" placeholder="password" name="password" required />
																<button className="btn btn-light bg-transparent" type="button" onClick={this.passwordVisability} id="button-addon2"><FontAwesomeIcon icon={this.state.password.visible===true?'eye':'eye-slash'} /> <i className="ri-eye-off-line align-middle"></i></button>
															</div>
															<div className="mt-2">
																<div className="form-check">
																	<input className="form-check-input" type="checkbox" value="" id="defaultCheck1" name="remember" />
																	<label className="form-check-label text-muted fw-normal" htmlFor="defaultCheck1"> Remember password ? </label>
																</div>
															</div>
														</div>
														{this.state.cookies === false ?
															<p className="my-1" style={{color: '#ff0000'}}>
																* You need cookies enabled to use this site
															</p>
														:
															<div className="col-xl-12 d-grid mt-3">
																<Button type="submit">Sign In</Button>
															</div>
														}
													</div>
													<div className="text-center ">
														<p className="fs-12 text-muted mt-4 mb-0">Dont have an account? <Link to="/register" className="text-primary">Sign Up</Link></p>
													</div>
												</div>
											</Form>
										</div>
										<div className="col-xl-6 col-md-6 ps-0 text-fixed-white rounded-0 d-none d-md-block  ">
											<div className="card custom-card mb-0 cover-background overflow-hidden rounded-end rounded-0">
												<div className="card-img-overlay d-flex  align-items-center p-0 rounded-0">
													<div className="card-body p-5 rectangle3">
														<div>
															<a href="https://ultrastream.io"> <img src={`https://cloud.ultrastream.io/images/logo-us-large.png?d=${Math.floor(Date.now()/1000)}`} alt="logo" className="toggle-logo" width={"100%"} /></a>
														</div>
														<h6 className="mt-4 fs-15 op-9  text-fixed-white">Sign In</h6>
														<div className="d-flex mt-3">
															<p className="mb-0 fw-normal fs-14 op-7  text-fixed-white">Log in to Ultrastream Account to view and manage your active subscriptions.</p>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</>
		);
	}
}